<template>
  <div>
    <div>
<!--    <div class="left_tree" v-show="showLeft">-->
<!--      <a-spin :spinning="treeSpin" style="height: 100%">-->
<!--        <div>-->
<!--          <a-radio-group v-model="type" @change="handleChange">-->
<!--            <a-radio-button value="dept">-->
<!--              部门-->
<!--            </a-radio-button>-->
<!--            &lt;!&ndash;            <a-radio-button value="customer">&ndash;&gt;-->
<!--            &lt;!&ndash;              员工&ndash;&gt;-->
<!--            &lt;!&ndash;            </a-radio-button>&ndash;&gt;-->
<!--          </a-radio-group>-->
<!--          <vxe-button @click="closeAll" style="margin-top: 12px">清空</vxe-button>-->
<!--        </div>-->
<!--        <div class="tree-box" v-if="type === 'dept'">-->
<!--          <a-tree-->
<!--              v-model="checkedKeys"-->
<!--              :show-icon="true"-->
<!--              checkable-->
<!--              :expanded-keys="expandedKeys"-->
<!--              :auto-expand-parent="autoExpandParent"-->
<!--              :selected-keys="selectedKeys"-->
<!--              :tree-data="treeData"-->
<!--              :selectable="false"-->
<!--              :replaceFields="{children:'children', title:'deptName', key:'deptId'}"-->
<!--              @expand="onExpand"-->
<!--              @check="onSelect"-->
<!--          >-->
<!--            <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>-->
<!--            <a-icon type="cluster" slot="region" style="color:#52c41a"/>-->
<!--          </a-tree>-->
<!--        </div>-->
<!--        <div class="tree-box" v-if="type === 'customer'">-->
<!--          <Tree :list="treeData" :selectedUser="selectedUser" :userName="''" :detph="0"-->
<!--                @change="checkedUser"></Tree>-->
<!--        </div>-->
<!--      </a-spin>-->
<!--    </div>-->
<!--    <div class="right_table" :class="{showLeft:!showLeft}">-->
<!--      <a-icon type="left-circle" class="close" @click="showLeft = false" v-if="showLeft"/>-->
<!--      <a-icon type="right-circle" class="close" @click="showLeft = true" v-else/>-->
      <x-grid
          :id="'formList'"
          :rowId="rowId"
          :pager-config="pagerConfig"
          :form-config="formConfig"
          :url="url"
          :columns="columns"
          :checkbox-config="checkboxConfig"
          :toolbar-config="toolbarConfig"
          :print-config="printConfig"
          :export-config="exportConfig"
          ref="grid"
          :other-params="{
          startDate,endDate,isNotFollow,isTodayFollow,fromIndexParam,deptId,//followUserId,regionId,dealerId,
        }"
          :cellClick="chooseRow"
          :cellDbClick="updateRow"
          @toolbar-addData="addRow"
          @toolbar-delData="delRow"
      >
        <template v-slot:[toolbarConfig.templatelSlots]>

        </template>
      </x-grid>
    </div>
    <!-- 详情页 -->
    <formModal
        title="线索管理详情"
        centered
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
        :closable="true"
        @cancelled="closeDetailPop"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          v-if="editModalVisible"
          ref="detailForm"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)"
      >
      </detailForm>
    </formModal>

  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";
//新增的
import {XEUtils} from "@/utils/common/FormBase";
// import Tree from "@/components/picker/Tree";

//新增的结束

console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除
// import {dataApi} from '@/services/comm/userManage';
// console.log(dataApi)

import detailForm from "@/pages/web/clue/clueManage/clueManageDetail";

//弹出层组件
import {mapMutations, mapState} from "vuex";
import {dataApi} from "@/services/clue/clueManage";
import {dataApi as touchChannelApi} from "@/services/comm/clueTouchChannel";
// import user from "@/services/user";

const fac = XGrid.factory;

//列表接口
const url = api.clue.CLUE;

//主键
const rowId = "clueId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("clueId", "线索id", 120),
  fac.makeColumn("poolId", "公海线索ID", 120),
  fac.makeColumn("regionName", "经理部", 120),
  fac.makeColumn("dealerName", "经销商", 120),
  fac.makeColumn("custName", "客户", 120),
  fac.makeColumn("mobile", "联系电话", 120),
  fac.makeColumn("sexName", "客户性别", 120),
  fac.makeColumn("idCardCode", "身份证号/社会统一信用代码", 120),
  fac.makeColumn("custCategoryName", "客户类型", 120),
  fac.makeColumn("custIdentityName", "客户身份", 120),
  fac.makeColumn("provinceCityName", "省市", 120),
  fac.makeColumn("firstFollowDate", "首次跟进时间", 120),
  fac.makeColumn("lastFollowDate", "最近跟进时间", 120),
  fac.makeColumn("visitedName", "是否到店", 120),
  fac.makeColumn("reportTypeName", "到店类型", 120),
  fac.makeColumn("clueStatus", "线索状态", 120),
  fac.makeColumn("totalFollowCount", "跟进次数", 120),
  fac.makeColumn("ontimeFollowCount", "按时跟进次数", 120),
  fac.makeColumn("overFollowCount", "超时跟进次数", 120),
  fac.makeColumn("strainName", "意向品系", 100),
  fac.makeColumn("fuelTypeName", "燃料类型", 100),
  fac.makeColumn("wantCount", "预购数量(台)", 120),
  fac.makeColumn("buyCount", "订车数量(台)", 120),
  fac.makeColumn("firstWantLevelName", "首次意向等级", 120),
  fac.makeColumn("wantLevelName", "意向等级", 100),
  fac.makeColumn("wantBrandName", "意向品牌", 100),
  fac.makeColumn("dealChanceName", "成交概率", 100),
  fac.makeColumn("clueSourceName", "线索来源", 120),
  fac.makeColumn("touchChannelName", "触达渠道", 120,"center"),
  fac.makeColumn("nextCallonDate", "下次跟进时间", 180, "center"),
  fac.makeColumn("createDate", "线索创建时间", 180, "center"),
  fac.makeColumn("clueUserName", "负责人", 100, "center"),
  fac.makeColumn("batholithNo", "底盘号", 160, "center"),
  fac.makeColumn("dealCount", "成交台数", 160, "center"),
  fac.makeColumn("dealDate", "成交时间", 120),
  fac.makeColumn("failureReason", "战败原因", 160, "center"),
  fac.makeColumn("failDate", "战败时间", 160, "center"),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "custName"},//客户
  {field: "mobile"},//联系电话
  // {field: 'email'},
  {
    field: "strainId",
    title:"意向品系",
    type: "select",
    options: [],
  },//意向品系
  {field: "wantCount"},//预购数量(台)
  {field: "buyCount"},//购车数量
  {
    field: "wantLevel",
    title: "意向等级",
    type: "select",
    options: [],
  },//意向等级
  {
    field: "dealChance",
    title:"成交概率",
    type: "select",
  },//成交概率
  {
    field: "touchChannelName",
    title: "触达渠道",
    type: "select",
    options: [],
  },//触达渠道
  {
    field: "clueSourceId",
    title: "线索来源",
    type: "select"
  },//线索来源
  {
    field: "clueStatus",
    title: "线索状态",
    type: "select"
  },//负责人
  {field: "clueUserName"},//负责人
  {
    field: "regionId",
    // 'customSearch': true,
    title: "经理部",
    type: "select",
    options: [],
  },
  {
    field: "dealerName",
    // 'customSearch': true,
    title: "经销商",
    type: "search-select",
    options: [],
  },
  {
    field: 'nextCallonDate',
    title: "下次跟进时间",
    type: 'dateRange',
  },
  {
    field: 'createDate',
    title: "线索创建时间",
    type: 'dateRange',
  },
  {
    field: 'batholithNo',
    title: "底盘号"
  },
  {
    field: 'failureReason',
    title: "战败原因"
  },
  {
    field: 'failDate',
    title: "战败时间",
    type: 'dateRange',
  },
  { field: 'clueId'},
  { field: 'poolId', title: "公海线索ID"},
   {
    field: 'dealDate',
    title: "成交时间",
    type: 'dateRange',
  },
  {
    field: "visitedName",
    // 'customSearch': true,
    title: "是否到店",
    type: "search-select",
    options: [],
  },
  {
    field: "reportTypeId",
    // 'customSearch': true,
    title: "到店类型",
    type: "search-select",
    options: [],
  }
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  export: true,
  import: false,
  delData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {
  let region = {
    isRegion: 1,
    isDealer: 0
  }
  let dealer = {
    isRegion: 0,
    isDealer: 1
  }
  // this.strainOptions = await loadBaseCodeData('CD200007')
  let strainData = await dataApi.getStrainList();
  console.log(this.strainOptions)
  this.wantLevelOptions = await loadBaseCodeData('CD200002')
  this.regionOptions = await dataApi.selection(region);//经理部
  this.dealerOptions = await dataApi.selection(dealer);//经销商
  this.dealChanceOptions = await loadBaseCodeData('CD200008')//成交概率
  this.clueSourceOptions = await loadBaseCodeData('CD200004')//线索来源

  // 加载触达渠道数据
  let touchChannelData = await touchChannelApi.getAllChannels();
  this.touchChannelOptions = touchChannelData.data || [];

  // let commCodeData = await dataApi.getCommCode();
  // let DeptUsers = await dataApi.getDeptUsers();
  // if(DeptUsers.code!==200){
  //
  // }
  // 经理部下拉处理
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);
  this.loadSearchOption({
    regionId: this.regionOptions,
  })
  // 经销商下拉处理
  this.dealerOptions = this.dealerOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptName
    }
  })
  this.dealerOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealerOptions);
  this.loadSearchOption({
    dealerName: this.dealerOptions,
  })

  this.strainOptions = strainData.data.map(v => {
    return {
      label: v.strainName,
      value: v.strainId,
    }
  })
  this.strainOptions = [{
    value: '',
    label: '全部'
  }].concat(this.strainOptions);
  this.loadSearchOption({
    strainId: this.strainOptions,
  })

  this.wantLevelOptions = this.wantLevelOptions.map(v => {
    return {
      label: v.label,
      value: v.value
    }
  })
  this.wantLevelOptions = [{
    value: '',
    label: '全部'
  }].concat(this.wantLevelOptions);
  this.loadSearchOption({
    wantLevel: this.wantLevelOptions,
  })
  //成交概率
  this.dealChanceOptions = this.dealChanceOptions.map(v => {
    return {
      label: v.label,
      value: v.value
    }
  })
  this.dealChanceOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealChanceOptions);
  this.loadSearchOption({
    dealChance: this.dealChanceOptions,
  })

////线索来源
  this.clueSourceOptions = this.clueSourceOptions.map(v => {
    return {
      label: v.label,
      value: v.value
    }
  })
  this.clueSourceOptions = [{
    value: '',
    label: '全部'
  }].concat(this.clueSourceOptions);
  this.loadSearchOption({
    clueSourceId: this.clueSourceOptions,
  })

  // 触达渠道
  this.touchChannelOptions = this.touchChannelOptions.map(v => {
    return {
      label: v.channelName,
      value: v.channelName
    }
  })
  this.touchChannelOptions = [{
    value: '',
    label: '全部'
  }].concat(this.touchChannelOptions);
  this.loadSearchOption({
    touchChannelName: this.touchChannelOptions,
  })


  const clueStatusOptions = [
    { value: '', label: '全部'},
    { value: '成交', label: '成交'},
    { value: '失败', label: '失败'},
    { value: '待处理', label: '待处理'},
    { value: '跟进中', label: '跟进中'},
    { value: '超时', label: '超时'}
  ]
  this.loadSearchOption({
    clueStatus: clueStatusOptions,
  })

  // 是否到店
  const visitedOptions = [
    { value: '', label: '全部'},
    { value: '是', label: '是'},
    { value: '否', label: '否'}
  ]
  this.loadSearchOption({
    visitedName: visitedOptions,
  })

  // 到店类型
  const reportTypeNameOptions = [
    { value: '', label: '全部'},
    { value: '20000054', label: '邀请到店'},
    { value: '20000053', label: '上门拜访'}
  ]
  this.loadSearchOption({
    reportTypeId: reportTypeNameOptions,
  })
}

export default {
  mixins: [GridMixin],
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   // delRow: 'DELETE',
  //   // importMethod:'IMPORT',
  //   // exportMethod:'EXPORT',
  // },
  components: {
    detailForm,
    //新增的开始
    // Tree
    //  新增的结束

  },
  computed: {
    ...mapState("account", {currUser: "user"}),
  },
  watch: {
    $route: {
      handler: function (newValue, oldValue) {
        console.log(350, oldValue, newValue);
        if (oldValue && newValue.path === '/clue/clueManage') {
          console.log('123======');
          this.startDate = this.$store.state.setting.startTime || null
          this.endDate = this.$store.state.setting.endTime || null
          this.isTodayFollow = this.$store.state.setting.isTodayFollow || null
          this.$nextTick(() => {
            this.refresh()
          })
        }else {
          this.setStartTime(null)
          this.setEndTime(null)
          this.setIsTodayFollow(0)
        }
      },

      immediate: true,
    },

    'formData.regionId'(val) { //经理部 联动经销商
      console.log(val);
      this.formData.dealerName =null
      this.getDealerData(val)
    }
  },
  data() {
    return {
      // popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      exportConfig:{
        remote: true,
        types: ['xlsx'],
        modes: ['all']
      },
      userIdList: [],
      strainOptions: [],
      wantLevelOptions: [],
      touchChannelOptions: [],
      startDate: this.$store.state.setting.startTime || null,
      endDate: this.$store.state.setting.endTime || null,
      isTodayFollow: this.$store.state.setting.isTodayFollow || null,
      isNotFollow: this.$route.query.isNotFollow,
      fromIndexParam: this.$route.query.fromIndexParam,
      //  新增的
      // regionId: '', dealerId: '',
      deptId: '',
      //角色树
      autoExpandParent: false,
      defaultExpandedKeys: [],
      selectedKeys: [],
      expandedKeys: [],
      checkedKeys: [],
      deptList: [],
      treeData: [],
      selectedUser: [],
      treeSpin: false,
      showLeft: false,
      type: 'dept',
      //  新增的结束
      formData:null,//筛选项数据
    };
  },
  mounted() {
    //  新增的
    this.init();
    //  新增的结束
    this.formData = this.$refs.grid.$refs.xGrid.formData; //获取筛选项
  },
  methods: {
    ...mapMutations('setting', ['setStartTime', 'setEndTime', 'setIsTodayFollow']),
    loadBaseData,
    closeDetailPop() {
      this.editModalVisible = false;
    },
    async createAccount() {
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length != 1) {
        this.$message.error('请选择一条数据');
        return;
      }
      console.log(rows)
      const userId = rows[0].userId
      console.log(userId)
      await dataApi.accountNumber(userId).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg)
        }
        console.log(res)
        this.refresh();
      }).catch(e => {
        console.log(e);
      })
    },
    merchants() {

      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      console.log(rows)

      this.userIdList = rows.map((i) => {
        return i.userId;
      }).join(',')
      console.log(this.userIdList)
      this.chooseOpenPop('merchantsAuthorization', 1)
    },
    closeLog() {
      this.logModalVisible = false;
    },
    //  新增的
    init() {
      dataApi.popSelect().then(res => {
        this.treeData = XEUtils.toArrayTree(res.data, {
          parentKey: 'parentId',
          key: 'deptId',
          children: 'children'
        })
      })
    },
    handleChange() {
      this.closeAll()
      this.init()
    },
    closeAll() {
      this.checkedKeys = []
      //this.followUserId = ''
      this.regionId = ''
      this.dealerId = ''
      this.deptId = ''
      XEUtils.mapTree(this.treeData, item => {
        if (item.userList) {
          item.userList.map(user => {
            user.checked = false
          })
        }
        return item
      })
      this.selectedUser = []
      this.$nextTick(() => {
        this.refresh()
      })
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },

    onSelect(selectedKeys, {checkedNodes}) {
      this.selectedKeys = selectedKeys
      let regionId = [], dealerId = [], deptId = []//三个数组
      checkedNodes.forEach(item => {//对象里的每一个
        if (item.data.props.isDealer === 1) {
          dealerId.push(item.key)
        } else if (item.data.props.isRegion === 1) {
          regionId.push(item.key)
        } else {
          deptId.push(item.key)
        }
      })
      this.regionId = regionId.toString()
      this.dealerId = dealerId.toString()
      this.deptId = deptId.toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },
    checkedUser(user) {
      if (user.checked) {
        this.selectedUser.push(user)
      } else {
        this.selectedUser = this.selectedUser.filter(item => item.userId !== user.userId)
      }
      this.followUserId = this.selectedUser.map(item => {
        return item.userId
      }).toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },

    //  新增的结束
    /**
     * 经理部 经销商联动数据
     * @param id
     * @return {Promise<void>}
     */
    async getDealerData(id) {
      let dealer = {
        isRegion: 0,
        isDealer: 1,
        'filter.eq.parentId': id,
      }
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptName
        }
      })
      this.dealerOptions = [{
        value: '',
        label: '全部'
      }].concat(this.dealerOptions);
      this.loadSearchOption({
        dealerName: this.dealerOptions,
      })
    },
  },
};
</script>

<style scoped lang="less">
//新增的开始
/deep/ .ant-radio-group {
  display: flex;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
  }

  .item {
    margin: 16px 0;
  }
}

.left_tree {
  width: 260px;
  float: left;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}

.right_table {
  width: calc(100% - 260px);
  float: right;
  height: 100%;
  position: relative;

  .close {
    position: absolute;
    top: 50%;
    left: -18px;
    display: block;
    z-index: 1000;
    font-size: 36px;
    cursor: pointer;
    color: #fff;
    background-color: #bbb;
    border-radius: 18px;
  }
}

.showLeft {
  width: 100%;
}

//新增的结束
</style>
